import React from 'react';
import { useNotification, ToastNotification } from '../../contexts/NotificationContext';
import './Toast.css';

const ToastItem: React.FC<{ toast: ToastNotification }> = ({ toast }) => {
  const { dismissToast } = useNotification();

  const getIcon = () => {
    switch (toast.type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'info':
        return 'i';
      default:
        return 'i';
    }
  };

  return (
    <div role={toast.type === 'error' ? 'alert' : 'status'} className={`toast toast-${toast.type}`}>
      <div className="toast-icon">{getIcon()}</div>
      <div className="toast-content">
        <div className="toast-title">{toast.title}</div>
        <div className="toast-message">{toast.message}</div>
      </div>
      <button
        className="toast-close"
        onClick={() => dismissToast(toast.id)}
        aria-label="Close notification"
      >
        ×
      </button>
    </div>
  );
};

const ToastContainer: React.FC = () => {
  const { toasts } = useNotification();

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map(toast => (
        <ToastItem key={toast.id} toast={toast} />
      ))}
    </div>
  );
};

export default ToastContainer;
